<script>
	import { Button } from '$lib/components/ui/button';
	import { Ellipsis, ChevronDown } from 'lucide-svelte';
	import * as Popover from '$lib/components/ui/popover';
</script>

<Popover.Root>
	<Popover.Trigger class="flex items-center transition-colors hover:text-foreground/80">
		More <ChevronDown class=" mt-1 h-4 w-4" />
	</Popover.Trigger>

	<Popover.Content
		class="mr-4 flex w-[1250px] flex-col overflow-hidden rounded-xl p-0"
		align="start"
		sideOffset={24}
	>
		<div class="w-full bg-secondary">
			<div class="flex flex-col rounded-xl p-6">
				<div class="grid grid-cols-2 gap-4">
					<div class="">
						<h2
							class="scroll-m-20 pb-1 font-heading text-xl font-semibold tracking-tight transition-colors first:mt-0"
						>
							Become a Tassie Tour Guide!
						</h2>
						<p class=" text-sm">
							Love Tasmania? Love People? The Tassie Tours Guide Academy welcomes passionate
							individuals of all backgrounds and ages to join our Short Course and launch an
							exciting career in Tasmania's thriving tourism industry!
						</p>
					</div>
					<div class="">
						<h2
							class="scroll-m-20 pb-1 font-heading text-xl font-semibold tracking-tight transition-colors first:mt-0"
						>
							Continue your Tassie adventure with our sister companies
						</h2>
						<p class=" text-sm">
							At Tassie Tours, we're dedicated to showing you the best of Tasmania. Check out our
							sister companies for more ways to experience our beautiful island.
						</p>
					</div>
				</div>
				<!-- <div class="mb-4 h-1 w-10 rounded-full bg-tt-red"></div> -->
			</div>
		</div>
		<div class="grid grid-cols-8 gap-4 px-4 pb-4 pt-6">
			<Popover.Close class="col-span-4">
				<a
					data-sveltekit-noscroll
					href="/tour-guide-academy"
					data-sveltekit-prefetch
					class="group relative flex aspect-video h-[160px] w-48 w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
				>
					<enhanced:img
						loading="lazy"
						alt="Custom Private tours"
						class="absolute inset-0 h-full w-full object-cover"
						src="$lib/assets/images/tour-guide-academy.jpg?format=webp&format=avif&format=jpg"
						sizes="(min-width: 768px) 33vw, 100vw"
					/>

					<div
						class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
					></div>

					<div class="relative mx-auto lg:mx-0">
						<h3 class="text-center text-xl font-bold text-background">Tour Guide Academy</h3>
					</div>
				</a>
			</Popover.Close>
			<Popover.Close class="col-span-2">
				<a
					href="https://thewinehopper.com/"
					target="_blank"
					aria-label="the wine hopper"
					data-sveltekit-noscroll
					class="p-1"
				>
					<enhanced:img
						src="/src/lib/assets/logo/winehopper-black.png?w=200"
						class="h-auto w-full"
						alt="The Wine Hopper Logo"
						loading="lazy"
						sizes="(min-width: 768px) 200px, 150px"
					/>
				</a>
			</Popover.Close>
			<Popover.Close class="col-span-2">
				<a
					href="https://charterabus.com.au/"
					target="_blank"
					aria-label="the wine hopper"
					data-sveltekit-noscroll
					class="p-1"
				>
					<enhanced:img
						src="/src/lib/assets/logo/charter-a-bus.png?w=200"
						class="h-auto w-full px-4"
						alt="Charter a Bus Logo"
						loading="lazy"
						sizes="(min-width: 768px) 200px, 150px"
					/>
				</a>
			</Popover.Close>
			<!-- {#each privateTours.slice(0, 6) as tour}
					<Popover.Close>
						<a
							data-sveltekit-noscroll
							href={`/tours/${slugify(tour.name, { lower: true, strict: true, remove: `/[*+~.()'"!:@]/g` })}`}
							data-sveltekit-prefetch
							class="group relative flex aspect-video w-48 w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
						>
							{#if tour.images && tour.images.length > 0}
								<enhanced:img
									alt={tour.name}
									class="absolute inset-0 h-full w-full object-cover"
									src={Object.entries(enhancedImages).find(
										([key, value]) => key === tour.images[0].itemUrl
									)[1].default}
								/>
							{:else}
								<File class="h-48 w-full object-cover text-muted-foreground" />
							{/if}
							<div
								class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
							></div>

							<div class="relative mx-auto lg:mx-0">
								<h3 class="text-center text-sm font-bold text-background">
									{tour.name.split('-')[1]}
								</h3>
							</div>
						</a>
					</Popover.Close>
				{/each} -->
		</div>
		<!-- <div class="flex rounded-xl px-6 pb-2">
				<Popover.Close>
					<Button
						href="/private-tours"
						variant="link"
						class="pl-0 text-sm font-semibold text-foreground"
					>
						Learn more <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
				</Popover.Close>
				<Popover.Close>
					<Button
						href="/custom-private-tours"
						variant="link"
						class="pl-0 text-sm font-semibold text-foreground"
					>
						Custom private tours <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
				</Popover.Close>
			</div> -->
	</Popover.Content>
</Popover.Root>
<!-- <Popover.Root>

	<Popover.Trigger class="flex items-center transition-colors hover:text-foreground/80">
		More <ChevronDown class=" mt-1 h-4 w-4" />
	</Popover.Trigger>
	<Popover.Content sideOffset={24} class="w-[225px] px-0 ">
		<div class="space-y-2">
			<h4 class="px-4 text-center text-sm">
				Continue your Tassie adventure with our sister companies.
			</h4>
			<div class="flex flex-col gap-2">
				<a
					href="https://thewinehopper.com/"
					target="_blank"
					aria-label="the wine hopper"
					data-sveltekit-noscroll
					class="p-1"
				>
					<enhanced:img
						src="/src/lib/assets/logo/winehopper-black.png?w=200"
						class="h-auto w-full"
						alt="The Wine Hopper Logo"
						loading="lazy"
						sizes="(min-width: 768px) 200px, 150px"
					/>
				</a>
				<a
					href="https://charterabus.com.au/"
					target="_blank"
					aria-label="the wine hopper"
					data-sveltekit-noscroll
					class="p-1"
				>
					<enhanced:img
						src="/src/lib/assets/logo/charter-a-bus.png?w=200"
						class="h-auto w-full px-4"
						alt="Charter a Bus Logo"
						loading="lazy"
						sizes="(min-width: 768px) 200px, 150px"
					/>
				</a>
			</div>
		</div></Popover.Content
	>
</Popover.Root> -->
